exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  margin: 30px; }\n\n.image {\n  height: 100px;\n  width: 100%;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  cursor: pointer; }\n\n.nav-link {\n  cursor: pointer; }\n\n.image:hover a {\n  display: block; }\n\n.image a {\n  cursor: pointer;\n  display: none; }\n  .image a i {\n    padding-bottom: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/+admin/modules/+file-manager/file-browser/file-browser.component.scss
// module id = 507
// module chunks = 6 13 14 15 16 17 21